import type {
  PhoneNumber,
  PropertyPhoneDefault
} from "views/phone-numbers/lib/types";
import type { PropertyEmailDefault } from "views/settings-communication/api/types";

const isAssignedTo = (phoneNumber: PhoneNumber, propertyId: number) =>
  phoneNumber.assign_all_properties ||
  (phoneNumber.assigned_properties ?? []).some(
    (property) => property.id === propertyId
  );

export const resolvePropertyPhone = ({
  propertyId,
  savedDefault,
  partnerNumbers
}: {
  propertyId: number;
  savedDefault: PropertyPhoneDefault | undefined;
  partnerNumbers: PhoneNumber[];
}): string | null => {
  if (savedDefault?.phone_number_id) return savedDefault.phone_number || null;

  const activeNumbers = partnerNumbers.filter(
    (phoneNumber) => phoneNumber.status === "active"
  );
  if (
    activeNumbers.some((phoneNumber) => isAssignedTo(phoneNumber, propertyId))
  )
    return null;

  const accountDefault =
    activeNumbers.find((phoneNumber) => phoneNumber.is_default) ??
    activeNumbers[0];
  return accountDefault?.phone_number || null;
};

export const resolvePropertyEmail = ({
  savedDefault,
  systemEmail
}: {
  savedDefault: PropertyEmailDefault | undefined;
  systemEmail: string | undefined;
}): string | null => {
  if (savedDefault?.mailbox_id) return savedDefault.mailbox_email;
  return systemEmail || savedDefault?.mailbox_email || null;
};
